/**
 * Lightweight wizard replacing twitter-bootstrap-wizard.
 * Keeps #rootwizard API: .bootstrapWizard({ onTabShow, onNext, onPrevious, onTabClick, nextSelector, previousSelector })
 * and method calls: previous / next / show / currentIndex
 */
(function ($) {
    'use strict';

    function CasaWizard($el, options) {
        this.$el = $el;
        this.options = $.extend({
            nextSelector: '.button-next',
            previousSelector: '.button-previous',
        }, options || {});
        this.$tabs = $el.find('ul.nav li');
        this.$panes = $el.find('.tab-content > .tab-pane');
        this.index = Math.max(0, this.$tabs.filter('.active').index());
        if (this.index < 0) this.index = 0;
        this._bind();
        this._show(this.index, true);
    }

    CasaWizard.prototype._bind = function () {
        var self = this;

        this.$el.on('click.casaWizard', 'ul.nav li a', function (e) {
            e.preventDefault();
            var idx = $(this).closest('li').index();
            if (typeof self.options.onTabClick === 'function') {
                if (self.options.onTabClick(self.$tabs.eq(self.index), self.$panes, self.index, idx) === false) {
                    return;
                }
            }
            self._show(idx);
        });

        if (this.options.nextSelector) {
            this.$el.on('click.casaWizard', this.options.nextSelector, function (e) {
                e.preventDefault();
                self.next();
            });
        }

        if (this.options.previousSelector) {
            this.$el.on('click.casaWizard', this.options.previousSelector, function (e) {
                e.preventDefault();
                self.previous();
            });
        }
    };

    CasaWizard.prototype._show = function (index, silent) {
        if (index < 0 || index >= this.$tabs.length) return;
        this.index = index;
        this.$tabs.removeClass('active').eq(index).addClass('active');
        this.$panes.removeClass('active show').eq(index).addClass('active show');

        var $bar = this.$el.find('.progress-bar');
        if ($bar.length) {
            var pct = this.$tabs.length <= 1 ? 100 : (index / (this.$tabs.length - 1)) * 100;
            $bar.css('width', pct + '%').attr('aria-valuenow', pct);
        }

        if (!silent && typeof this.options.onTabShow === 'function') {
            this.options.onTabShow(this.$tabs.eq(index), this.$panes, index);
        }
    };

    CasaWizard.prototype.next = function () {
        var next = this.index + 1;
        if (typeof this.options.onNext === 'function') {
            if (this.options.onNext(this.$tabs.eq(this.index), this.$panes, this.index) === false) {
                return;
            }
        }
        this._show(next);
    };

    CasaWizard.prototype.previous = function () {
        var prev = this.index - 1;
        if (typeof this.options.onPrevious === 'function') {
            if (this.options.onPrevious(this.$tabs.eq(this.index), this.$panes, this.index) === false) {
                return;
            }
        }
        this._show(prev);
    };

    CasaWizard.prototype.show = function (index) {
        this._show(index);
    };

    CasaWizard.prototype.currentIndex = function () {
        return this.index;
    };

    $.fn.bootstrapWizard = function (options) {
        if (typeof options === 'string') {
            var args = Array.prototype.slice.call(arguments, 1);
            var ret;
            this.each(function () {
                var inst = $(this).data('casaWizard');
                if (!inst) return;
                if (typeof inst[options] === 'function') {
                    ret = inst[options].apply(inst, args);
                }
            });
            return ret !== undefined ? ret : this;
        }

        return this.each(function () {
            var $el = $(this);
            var existing = $el.data('casaWizard');
            if (existing) {
                $el.off('.casaWizard');
            }
            var inst = new CasaWizard($el, options || {});
            $el.data('casaWizard', inst);
        });
    };
}(jQuery));
